export const API_URL = import.meta.env.VITE_API_URL!
export const BASE_URL = import.meta.env.DEV ? '/api/v1beta' : API_URL

export const AUDIT_BASE_URL = import.meta.env.DEV ? '/api' : `${API_URL}/api`

/**
 * Нормализует URL для скачивания файла из S3.
 * Если URL уже абсолютный (начинается с http) — возвращает как есть.
 * Если готовый relative path от бэкенда — в dev отдаём как есть (Vite proxy),
 * в prod делаем абсолютным через origin API_URL.
 * Иначе — сырой S3-ключ, оборачиваем в proxy URL.
 */
export const resolveDownloadUrl = (url: string): string => {
  if (url.startsWith('http://') || url.startsWith('https://')) return url
  if (url.startsWith('/')) {
    if (import.meta.env.DEV) return url
    return `${new URL(API_URL).origin}${url}`
  }
  return `${BASE_URL}/exports/file?key=${encodeURIComponent(url)}`
}

/**
 * Скачивает файл по URL (CDN или прокси через бэкенд) и триггерит загрузку в браузере.
 * Использует fetch вместо axios, т.к. эндпоинт публичный и axios добавляет baseURL,
 * что приводит к double-path (404).
 */
export const downloadExportFile = async (downloadUrl: string, filename: string): Promise<void> => {
  const fileUrl = resolveDownloadUrl(downloadUrl)

  const resp = await fetch(fileUrl)
  if (!resp.ok) throw new Error('Download failed')
  const blob = await resp.blob()

  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}
